import React from 'react'
import { HelpText } from './helpText'
import { ReturnButton } from './returnButton'

const BadGateway = () => {
  return (
    <div data-testid="complaint-badgateway">
      <h2>Sorry!</h2>
      <p>
        The site is currently down. <HelpText />
      </p>
      <ReturnButton />
    </div>
  )
}

export default BadGateway
